import React from 'react';
export function HeroSection() {
  return <section className="relative bg-cream-light pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-87">
          <div className="max-w-2xl" data-id="element-88">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-ink leading-tight mb-6" data-id="element-89">
              Feeling like bloating and belly discomfort are stealing your
              comfort after 40?
            </h1>
            <p className="text-lg md:text-xl text-ink/80 mb-8 leading-relaxed font-sans" data-id="element-90">
              Discover the 14-day plan to reduce belly bloat—no calorie
              counting, no extreme diets, and real results you'll feel in your
              clothes.
            </p>
            <div className="bg-sage-light/20 border border-sage-light/30 rounded-xl p-6 mb-8" data-id="element-91">
              <p className="text-ink font-medium text-lg" data-id="element-92">
                A simple, calm, and effective plan for men and women 40+: reduce
                bloating, relieve discomfort, and feel a lighter waistline in
                just 2 weeks.
              </p>
            </div>
            <div className="bg-sage-dark rounded-2xl p-6 sm:p-8 text-white text-center max-w-sm" data-id="element-93">
              <span className="inline-block bg-white/20 text-white text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-3" data-id="element-94">
                Limited-Time Offer
              </span>
              <div className="flex items-center justify-center gap-3 mb-1" data-id="element-95">
                <span className="text-xl text-white/50 line-through" data-id="element-96">$27</span>
                <span className="text-4xl sm:text-5xl font-bold" data-id="element-97">
                  <span className="text-xl align-top" data-id="element-98">$</span>9
                  <span className="text-2xl" data-id="element-99">.38</span>
                </span>
              </div>
              <p className="text-sm text-sage-light font-medium mb-4" data-id="element-100">
                You save over 65%
              </p>
              <a href="https://wellnessresetzone.com/cart/47635769327668:1" target="_blank" rel="noopener noreferrer" className="inline-flex w-full justify-center items-center px-8 py-4 text-lg font-semibold rounded-full text-sage-dark bg-white hover:bg-cream-light shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5" data-id="element-101">
                Get Your Copy Now
              </a>
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-lg lg:max-w-none" data-id="element-102">
            <div className="absolute inset-0 bg-sage-light/20 rounded-full blur-3xl transform scale-110 -z-10" data-id="element-103"></div>
            <img src="https://cdn.magicpatterns.com/uploads/m4nt6t4k6zVd5tp5B79GQr/14_day_dbloat.png" alt="14-Day Belly Reset Plan eBook displayed on tablet and phone" className="w-full h-auto rounded-2xl shadow-2xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-104" />
          </div>
        </div>
      </div>
    </section>;
}